import React from "react";
import { Link } from "react-router-dom";
import { useSanctions } from "../context/SanctionsContext";

/**
 * MutedNotice — заменяет инпут / форму при активной мут-санкции.
 *
 * Использование:
 *   const { isMuted } = useSanctions();
 *   if (isMuted) return <MutedNotice />;
 *
 * action: 'comment' (default) | 'publish' | 'chat'
 */
export default function MutedNotice({ action = "comment", variant = "block" }) {
  const { muteInfo, cantPublishInfo } = useSanctions();
  const info = action === "publish" ? (cantPublishInfo || muteInfo) : muteInfo;
  if (!info) return null;

  const verb = action === "publish" ? "публиковать"
            : action === "chat" ? "писать в чат"
            : "комментировать";
  const until = info.banned_until ? info.banned_until.replace("T", " ").slice(0, 16) : null;
  const appealUrl = `/ban-appeals/new?type=${encodeURIComponent(info.type)}&id=${info.id || ""}`;

  if (variant === "inline") {
    return (
      <div style={{
        fontSize: 13, color: "#a01010",
        background: "rgba(255,80,80,0.15)",
        border: "1px solid rgba(225,92,92,0.5)",
        borderRadius: 8, padding: "8px 12px",
        display: "inline-flex", alignItems: "center", gap: 8,
      }}>
        ⚠ Вы временно не можете {verb}{until && <> · до {until}</>}{" "}
        <Link to={appealUrl} style={{ color: "#3357FF", fontWeight: 600 }}>
          подать жалобу
        </Link>
      </div>
    );
  }

  return (
    <div style={{
      background: "linear-gradient(135deg, rgba(255,80,80,0.18) 0%, rgba(180,30,30,0.28) 100%)",
      border: "1.5px solid #e15c5c",
      borderRadius: 12, padding: "14px 18px",
      color: "#fff",
      display: "flex", alignItems: "flex-start", gap: 14, flexWrap: "wrap",
    }}>
      <div style={{ fontSize: 24, lineHeight: 1, flexShrink: 0 }}>⚠</div>
      <div style={{ flex: "1 1 240px", minWidth: 180 }}>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>
          Вы временно не можете {verb}
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.45, opacity: 0.9 }}>
          {info.reason && (<div><b>Причина:</b> {info.reason}</div>)}
          {until && (<div><b>До:</b> {until}</div>)}
        </div>
      </div>
      <Link to={appealUrl} style={{
        padding: "8px 14px", background: "#fff",
        color: "#a01010", borderRadius: 8,
        fontSize: 13, fontWeight: 700, textDecoration: "none",
        whiteSpace: "nowrap", alignSelf: "center",
      }}>
        Подать жалобу
      </Link>
    </div>
  );
}
